export default {
  validationError: {
    allowedMinTooLarge: 'min > max',
    allowedMaxTooSmall: 'max < min',
    defaultValueExceedAllowed: 'Predvolená hodnota prekračuje povolený rozsah',
  },
};
